import cxs from 'cxs';

export const CARD_OVERLAY_FAV_ICON = cxs({
  cursor: 'pointer'
});